import Vue from 'vue'
import Vuex from 'vuex'
import { DINGTALK_CORP_ID } from '../config/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: (() => {
      try {
        const raw = window.localStorage.getItem('user')
        if (!raw) return {}
        const parsed = JSON.parse(raw)
        if (parsed && parsed.userName) return parsed
        return {}
      } catch (e) {
        window.localStorage.removeItem('user')
        return {}
      }
    })(),
    activityId: window.localStorage.getItem('ipip_activity_id') || '',
    curCreateActivity:{
    },
    adminMenus: [],
    dialogWidth:'100%',
    dingtalkCorpId: DINGTALK_CORP_ID
  },
  mutations: {
    login (state, user) {
      // 钉钉登录不存储密码到localStorage
      const storeUser = {
        userName: user.userName,
        loginType: user.loginType || 'password',
        jobNumber: user.jobNumber || ''
      }
      if (user.loginType !== 'dingtalk') {
        storeUser.password = user.password
      }
      state.user = storeUser
      window.localStorage.setItem('user', JSON.stringify(storeUser))
    },
    logout(state){
      state.user = {}
      window.localStorage.removeItem('user')
    },
    createActive(state,data){
       state.curCreateActivity = data
       window.localStorage.setItem('curCreateActivity', JSON.stringify(data))
    },
    initAdminMenu (state, menus) {
      state.adminMenus = menus
    },
    // 设置钉钉 CorpId
    setDingtalkCorpId (state, corpId) {
      state.dingtalkCorpId = corpId
    },
    setActivityId (state, aid) {
      state.activityId = aid
      window.localStorage.setItem('ipip_activity_id', aid)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js